import { FaturasModel } from "model/api/gestao/fatura/faturas-model";
import { EnumTipoFatura } from "model/enums/enum-tipo-fatura";
import { CardNaoEncontrado } from "views/components/cards";
import { CardFaturaComissoesPagas } from "views/components/cards/card-fatura-comissoes-pagas/card-fatura-comissoes-pagas";
import { InformacaoIcon } from "views/components/icons";

export interface FaturasGridProps {
  list: Array<FaturasModel>;
  carregando: boolean;
  selectedList: Array<string>;
  onCardSelected: (id: string, tipo?: EnumTipoFatura) => any;
  onCardChecked: (id: string) => any;
}

export const FaturaComissoesPagasListData = (props: FaturasGridProps) => {

  const onCardSelected = (id: string, tipo?: EnumTipoFatura) => {
    props.onCardSelected(id, tipo);
  };

  const onCardChecked = (id: string) => {
    props.onCardChecked(id);
  };

  return (
    <>
      {props.list.length === 0 && !props.carregando && (
        <CardNaoEncontrado
          mensagem="Nenhuma Fatura Encontrada."
          icon={<InformacaoIcon tipo="GERAL" />}
        />
      )}
      {props.list.length > 0 &&
        props.list.map((fatura, index) => {
          return (
            <CardFaturaComissoesPagas
              selected={
                props.selectedList.filter((item) => item === fatura.id).length >
                  0
                  ? true
                  : false
              }
              onCheck={onCardChecked}
              onClick={onCardSelected}
              model={fatura}
              key={index}
            />
          );
        })}
    </>
  );
};
